import { useEffect } from 'react';

interface UseSetIntervalProps {
  action: () => void;
  disabled?: boolean;
  interval?: number;
  dependencyArray: any[];
}

export const useSetInterval = ({ disabled, action, interval = 1000, dependencyArray }: UseSetIntervalProps) => {
  useEffect(() => {
    if (disabled) return;
    let intervalId: NodeJS.Timeout;

    intervalId = setInterval(() => {
      action();
    }, interval);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, dependencyArray);
};
